import React from 'react';
import { Link } from 'react-router-dom';
import { FaBed, FaBath, FaRuler, FaMapMarkerAlt } from 'react-icons/fa';
import { formatPrice, getPropertyTypeLabel, getStatusColor } from '../services/api';
import './PropertyCard.css';

const PropertyCard = ({ property }) => {
  const {
    id, title, price, currency, type, status,
    bedrooms, bathrooms, area, city, imageUrls,
    featured,
  } = property;

  const mainImage = imageUrls?.[0] || 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=600&auto=format';

  return (
    <Link to={`/propiedades/${id}`} className="property-card">
      {/* Imagen */}
      <div className="property-card__image-wrapper">
        <img
          src={mainImage}
          alt={title}
          className="property-card__image"
          loading="lazy"
        />
        <div
          className="property-card__status"
          style={{ background: getStatusColor(status) }}
        >
          {status === 'DISPONIBLE' ? 'Disponible' :
           status === 'VENDIDA' ? 'Vendida' :
           status === 'ALQUILADA' ? 'Alquilada' : 'Reservada'}
        </div>
        <div className="property-card__type">{getPropertyTypeLabel(type)}</div>
        {featured && <div className="property-card__featured">⭐ Destacada</div>}
        {imageUrls?.length > 1 && (
          <div className="property-card__count">{imageUrls.length} fotos</div>
        )}
      </div>

      {/* Contenido */}
      <div className="property-card__body">
        <div className="property-card__price">{formatPrice(price, currency)}</div>
        <h3 className="property-card__title">{title}</h3>

        <div className="property-card__location">
          <FaMapMarkerAlt />
          <span>{city || 'El Salvador'}</span>
        </div>

        {/* Características */}
        <div className="property-card__features">
          {bedrooms != null && (
            <span className="property-card__feature">
              <FaBed /> {bedrooms} hab.
            </span>
          )}
          {bathrooms != null && (
            <span className="property-card__feature">
              <FaBath /> {bathrooms} baños
            </span>
          )}
          {area != null && (
            <span className="property-card__feature">
              <FaRuler /> {area.toLocaleString('es-SV')} m²
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
